module.exports = __webpack_public_path__ + "static/media/success-dt-fr.40d6954c.png";